import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Row,
  Col,
  Button,
  Space,
  message,
  Layout,
  Modal,
  Input,
  Select,
} from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import {
  createTypeInfraction,
  getTypeInfraction,
  updateTypeInfraction,
} from "../api/typeInfraction/infractionType";
import PermissionRender from "../components/PermissionRender";

const { Content } = Layout;
const { Option } = Select;

function TypesInfractions() {
  const [types, setTypes] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [newType, setNewType] = useState("");
  const [newTypeAr, setNewTypeAr] = useState("");
  const [newAmount, setNewAmount] = useState("");
  const [newRepeatedAmount, setNewRepeatedAmount] = useState("");
  const [category, setCategory] = useState("Rotation");
  const [editingType, setEditingType] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    setLoading(true);
    try {
      const data = await getTypeInfraction();
      setTypes(data);
    } catch (error) {
      message.error("Échec de la récupération des types d'infractions");
    } finally {
      setLoading(false);
    }
  };

  const handleAddType = async () => {
    if (newType.trim() && newTypeAr.trim() && newAmount && category) {
      try {
        await createTypeInfraction({
          name: newType,
          name_ar: newTypeAr,
          amount: parseFloat(newAmount),
          repeated_amount: parseFloat(newRepeatedAmount || newAmount),
          category: category,
        });

        setNewType("");
        setNewTypeAr("");
        setNewAmount("");
        setNewRepeatedAmount("");
        setCategory("Rotation");
        setIsModalVisible(false);
        fetchTypes();
        message.success("Type d'infraction ajouté");
      } catch (error) {
        message.error("Échec de l'ajout du type d'infraction");
      }
    } else {
      message.error(
        "Veuillez entrer un type d'infraction, un montant et une catégorie valides"
      );
    }
  };

  const handleEditType = (type) => {
    setIsEditing(true);
    setEditingType(type);
    setNewType(type.name);
    setNewTypeAr(type.name_ar);
    setNewAmount(type.amount);
    setNewRepeatedAmount(type.repeated_amount || type.amount);
    setCategory(type.category || "Rotation");
    setIsModalVisible(true);
  };

  const handleUpdateType = async () => {
    if (newType.trim() && newTypeAr.trim() && newAmount && category) {
      try {
        await updateTypeInfraction(
          editingType.id,
          newType,
          newTypeAr,
          parseFloat(newAmount),
          category,
          parseFloat(newRepeatedAmount || newAmount)
        );

        setNewType("");
        setNewTypeAr("");
        setNewAmount("");
        setNewRepeatedAmount("");
        setCategory("Rotation");
        setIsModalVisible(false);
        setIsEditing(false);
        fetchTypes();
        message.success("Type d'infraction mis à jour");
      } catch (error) {
        message.error("Échec de la mise à jour du type d'infraction");
      }
    } else {
      message.error(
        "Veuillez entrer un type d'infraction, un montant et une catégorie valides"
      );
    }
  };

  const restForm = () => {
    setNewType("");
    setNewTypeAr("");
    setNewAmount("");
    setNewRepeatedAmount("");
    setCategory("Rotation");
    setIsEditing(false);
  };

  const columns = [
    {
      title: "Type d'infraction",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "نوع المخالفة",
      dataIndex: "name_ar",
      key: "name_ar",
      align: "right",
    },
    {
      title: "Catégorie",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Montant",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Montant répété",
      dataIndex: "repeated_amount",
      key: "repeated_amount",
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      render: (text, record) => (
        <Space size="middle">
          <PermissionRender requiredPermission={["type_infraction", "update"]}>
            <Button
              icon={<EditOutlined />}
              onClick={() => handleEditType(record)}
            >
              Modifier
            </Button>
          </PermissionRender>
        </Space>
      ),
    },
  ];

  return (
    <Layout className="min-h-screen">
      <Content className="py-6 sm:px-6 lg:px-8">
        <Card className="mb-6 shadow-sm">
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24}>
              <PermissionRender requiredPermission={["type_infraction", "create"]}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setIsModalVisible(true)}
                  className="w-full"
                >
                  Créer un nouveau type d'infraction
                </Button>
              </PermissionRender>
            </Col>
          </Row>
        </Card>

        <Card className="shadow-sm">
          <Table
            dataSource={types.map((item, index) => ({ key: index, ...item }))}
            columns={columns}
            pagination={false}
            loading={loading}
          />
        </Card>

        <Modal
          title={
            isEditing
              ? "Modifier le Type d'Infraction"
              : "Ajouter un Type d'Infraction"
          }
          visible={isModalVisible}
          onOk={isEditing ? handleUpdateType : handleAddType}
          onCancel={() => {
            setIsModalVisible(false);
            restForm();
          }}
        >
          <Input
            placeholder="Type d'infraction"
            value={newType}
            onChange={(e) => setNewType(e.target.value)}
          />
          <Input
            placeholder="نوع المخالفة"
            value={newTypeAr}
            onChange={(e) => setNewTypeAr(e.target.value)}
            style={{ marginTop: "10px" }}
            dir="rtl"
          />
          <Select
            placeholder="Catégorie"
            value={category}
            onChange={(value) => setCategory(value)}
            style={{ width: "100%", marginTop: "10px" }}
          >
            <Option value="Rotation">Rotation</Option>
            <Option value="Abonnement">Abonnement</Option>
          </Select>
          <Input
            placeholder="Montant"
            type="number"
            value={newAmount}
            onChange={(e) => setNewAmount(e.target.value)}
            style={{ marginTop: "10px" }}
          />
          <Input
            placeholder="Montant répété (si vide, même montant que le premier)"
            type="number"
            value={newRepeatedAmount}
            onChange={(e) => setNewRepeatedAmount(e.target.value)}
            style={{ marginTop: "10px" }}
          />
        </Modal>
      </Content>
    </Layout>
  );
}

export default TypesInfractions;